import { Component, ElementRef, HostBinding } from '@angular/core';
import { IWizItemRenderer, WizTree, TreeItemWrapper, WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { IncExcContentObj } from '@wizeoo/akm-common-lib';

/**
 * rendu des contenus des IncExc
 */
@Component({
  selector: 'incex-content-renderer',
  templateUrl: './incex-content.renderer.html',
})
export class IncExcContentRenderer implements IWizItemRenderer<TreeItemWrapper<IncExcContentObj>, IncExcContentObj> {
  @HostBinding('style.width') elwidth: string = '100%';

  // donneés rempli par le composant wiz-tree
  data: IncExcContentObj;
  owner: WizTree<IncExcContentObj>;
  context: TreeItemWrapper<IncExcContentObj>;

  constructor(public elementRef: ElementRef) {}

  /** demande d'ajout d'un élément de clé */
  public addPart(e: MouseEvent): void {
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.INC_EXC_ADD_PART, this.data));
  }
}
